/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Resumes_This_May_Take_MomentInputs */

const en_resumes_this_may_take_moment = /** @type {(inputs: Resumes_This_May_Take_MomentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This may take a moment`)
};

const de_resumes_this_may_take_moment = /** @type {(inputs: Resumes_This_May_Take_MomentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dies kann einen Moment dauern`)
};

const fr_resumes_this_may_take_moment = /** @type {(inputs: Resumes_This_May_Take_MomentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cela peut prendre un moment`)
};

const es_resumes_this_may_take_moment = /** @type {(inputs: Resumes_This_May_Take_MomentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Esto puede tomar un momento`)
};

const it_resumes_this_may_take_moment = /** @type {(inputs: Resumes_This_May_Take_MomentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Potrebbe richiedere un momento`)
};

const nl_resumes_this_may_take_moment = /** @type {(inputs: Resumes_This_May_Take_MomentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dit kan even duren`)
};

const pl_resumes_this_may_take_moment = /** @type {(inputs: Resumes_This_May_Take_MomentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`To może chwilę potrwać`)
};

const fi_resumes_this_may_take_moment = /** @type {(inputs: Resumes_This_May_Take_MomentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tämä voi kestää hetken`)
};

const da_resumes_this_may_take_moment = /** @type {(inputs: Resumes_This_May_Take_MomentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dette kan tage et øjeblik`)
};

const sv_resumes_this_may_take_moment = /** @type {(inputs: Resumes_This_May_Take_MomentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Detta kan ta en stund`)
};

/**
* | output |
* | --- |
* | "This may take a moment" |
*
* @param {Resumes_This_May_Take_MomentInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const resumes_this_may_take_moment = /** @type {((inputs?: Resumes_This_May_Take_MomentInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Resumes_This_May_Take_MomentInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_resumes_this_may_take_moment(inputs)
	if (locale === "fr") return fr_resumes_this_may_take_moment(inputs)
	if (locale === "es") return es_resumes_this_may_take_moment(inputs)
	if (locale === "it") return it_resumes_this_may_take_moment(inputs)
	if (locale === "nl") return nl_resumes_this_may_take_moment(inputs)
	if (locale === "pl") return pl_resumes_this_may_take_moment(inputs)
	if (locale === "fi") return fi_resumes_this_may_take_moment(inputs)
	if (locale === "da") return da_resumes_this_may_take_moment(inputs)
	if (locale === "sv") return sv_resumes_this_may_take_moment(inputs)
	return en_resumes_this_may_take_moment(inputs)
});